

export class AssetsLocationDto {
    locationId: number;
    locationName: string;
    createdUser: string;
    isActive: boolean;
    updatedUser: string;
    versionFlag: number;
    plant?: number;
    locationHead?: string
    plantId?:number


    /**
     *
     * @param locationId
     * @param locationName
     * @param createdUser
     * @param isActive
     */
    constructor(

        locationId: number,
        locationName: string,
        createdUser: string,
        isActive: boolean,
        updatedUser: string,
        versionFlag: number,
        plant?: number,
        locationHead?: string,
        plantId?:number

        


    ) {
        this.locationId = locationId;
        this.locationName = locationName;
        this.createdUser = createdUser;
        this.isActive = isActive;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
        this.plant = plant;
        this.locationHead = locationHead
        this.plantId = plantId

    }
}

export const AssetLocationDtoDefault: AssetsLocationDto ={
    locationId:0,
    locationName: '',
    createdUser:"",
    isActive:true,
    // createdAt: new Date(),
    // updatedAt: new Date(),
    updatedUser: '',
    versionFlag: 1,
    locationHead:"",

}
